// @ts-expect-error [TS migration] Was not detected by flow
import React, { Node } from 'react';
import { useTranslation } from 'react-i18next';
import PhotoIcon from '@mui/icons-material/Photo';
import TableChartIcon from '@mui/icons-material/TableChart';

type MenuItemT = { name: string; icon: Node; action: () => void };

const useGetMenuItems = (
    exportTableData: FlowAnyFunction | null,
    exportPng: FlowAnyFunction | null,
    exportExcelData: FlowAnyFunction | null,
): MenuItemT[] => {
    const { t } = useTranslation();
    const menuItems: MenuItemT[] = [];

    if (exportPng)
        menuItems.push({
            name: t('gridChart.exportGraph'),
            icon: <PhotoIcon />,
            action: exportPng,
        });
    if (exportTableData)
        menuItems.push({
            name: t('gridChart.exportTable'),
            icon: <TableChartIcon />,
            action: exportTableData,
        });
    if (exportExcelData)
        menuItems.push({
            name: t('gridChart.exportExcel'),
            icon: <TableChartIcon />,
            action: exportExcelData,
        });

    return menuItems;
};

export default useGetMenuItems;
